module.exports = __webpack_public_path__ + "static/assets/7f456c741890132dd41d433bad4a8c4f.svg";